import './ManageOrganization.scss';
import { Button } from '@trackman/web-shared-components';

export const ManageOrganization = ({
  isDisabled,
  hasOrganizationId,
  setIsModalOn,
  setDisabled,
}: {
  isDisabled: boolean;
  hasOrganizationId: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  setDisabled: (isDisabled: boolean) => void;
}) => {
  return (
    <div className='admin-edit-section buttons-group'>
      <Button className='styled-button secondary' onClick={() => setDisabled(!isDisabled)}>
        {isDisabled ? 'Activate organization' : 'Disable organization'}
      </Button>
      {hasOrganizationId ? (
        <Button className='styled-button danger' onClick={() => setIsModalOn(true)}>
          Delete organization
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};
